import React from 'react';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import styles from '../FormulaireGraphe.module.scss';
import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import HoverButton from '../../../../UI/BoutonHover/BoutonHover';

const SelectField = ({
  label,
  name,
  value,
  onChange,
  options,
  disabled = false,
  helpIcon = null,
  helpText = null,
  customClass = '',
}) => {
  return (
    <div className={s.col_12}>
      <label className={styles.stil2}>
        {checkMot(label)}
        {helpIcon && (
          <HoverButton customClass={styles.btn_stile} imageUrl={helpIcon} />
        )}
        {helpText && (
          <HoverButton
            customClass={styles.btn_stile}
            texte={checkMot(helpText)}
          />
        )}
      </label>
      <select
        onChange={onChange}
        name={name}
        defaultValue={value}
        disabled={disabled}
        value={value}
        className={[s.custom_select, customClass].join(' ')}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {checkMot(option.label)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectField;
